module.exports = __webpack_public_path__ + "voicecall@2x.58dd772b2707df0cc986796f249ae80c.png";